export default __webpack_public_path__ + "dc9cd3724ab6f2db3cdbb8b132423f16.png";